// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { debounce } from 'lodash';

// Utils
import { hasChanged } from '../../utils/react/propsComparisons';

// Components
import Button from './Button';

const onClickHasChanged = hasChanged('onClick');
const onClickFnHasChanged = hasChanged('onClickFn');
const onDoubleClickHasChanged = hasChanged('onDoubleClick');
const mouseDownHasChanged = hasChanged('onMouseDown');
const mouseUpHasChanged = hasChanged('onMouseUp');

class DebouncedButton extends React.Component {
    constructor(props) {
        super(props);

        this.createDebouncedMouseHandlers(props);
    }

    componentWillReceiveProps(nextProps) {
        if (
            onClickHasChanged(this.props, nextProps) ||
            onClickFnHasChanged(this.props, nextProps) ||
            onDoubleClickHasChanged(this.props, nextProps) ||
            mouseDownHasChanged(this.props, nextProps) ||
            mouseUpHasChanged(this.props, nextProps)
        ) {
            this.createDebouncedMouseHandlers(nextProps);
        }
    }

    createDebouncedMouseHandlers = (props) => {
        this.onMouseDown = props.onMouseDown && debounce(props.onMouseDown, 250, { leading: true, trailing: false });
        this.onClick = props.onClick && debounce(props.onClick, 250, { leading: true, trailing: false });
        this.onDoubleClick =
            props.onDoubleClick && debounce(props.onDoubleClick, 250, { leading: true, trailing: false });
        this.onMouseUp = props.onMouseUp && debounce(props.onMouseUp, 250, { leading: true, trailing: false });
    };

    render() {
        return (
            <Button
                ref={this.props.forwardedRef}
                {...this.props}
                onClick={this.onClick}
                onDoubleClick={this.onDoubleClick}
                onMouseDown={this.onMouseDown}
                onMouseUp={this.onMouseUp}
            />
        );
    }
}

DebouncedButton.propTypes = {
    forwardedRef: PropTypes.object,
    children: PropTypes.oneOfType([PropTypes.element, PropTypes.array, PropTypes.string]).isRequired,
    onClick: PropTypes.func,
    onMouseDown: PropTypes.func,
    onMouseUp: PropTypes.func,
};

export default DebouncedButton;
